export default __webpack_public_path__ + "static/media/MotorFormBg.ffa676fa.svg";